export interface Category {
  id: string;
  nameIt: string;
  nameEn: string;
  url: string;
  icon: string;
  imageSeq: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameIt: 'Scarpe',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSeq: 'cat-shoes-01',
    description: 'Sneakers, scarpe sportive e casual dai migliori venditori cinesi',
  },
  {
    id: 'hoodies',
    nameIt: 'Felpe',
    nameEn: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-hoodies-02',
    description: 'Felpe con cappuccio, sweater e pullover di tendenza',
  },
  {
    id: 'tshirts',
    nameIt: 'T-Shirt',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-tshirts-03',
    description: 'Magliette grafiche, basic e streetwear dal mercato cinese',
  },
  {
    id: 'jackets',
    nameIt: 'Giacche',
    nameEn: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-jackets-04',
    description: 'Giacche, bomber, giubbotti e capispalla per ogni stagione',
  },
  {
    id: 'pants',
    nameIt: 'Pantaloni',
    nameEn: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    imageSeq: 'cat-pants-05',
    description: 'Pantaloni, jeans, cargo e shorts per uomo e donna',
  },
  {
    id: 'headwear',
    nameIt: 'Copricapi',
    nameEn: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageSeq: 'cat-headwear-06',
    description: 'Cappelli, berretti, bandane e accessori per la testa',
  },
  {
    id: 'sets',
    nameIt: 'Set Completi',
    nameEn: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageSeq: 'cat-sets-07',
    description: 'Set coordinati, tute complete e outfit abbinati',
  },
  {
    id: 'underwear',
    nameIt: 'Intimo',
    nameEn: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-line',
    imageSeq: 'cat-underwear-08',
    description: 'Intimo, biancheria e capi essenziali a prezzi convenienti',
  },
  {
    id: 'jersey',
    nameIt: 'Maglie Sportive',
    nameEn: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    imageSeq: 'cat-jersey-09',
    description: 'Maglie da calcio, basket e repliche sportive di qualità',
  },
  {
    id: 'accessories',
    nameIt: 'Accessori',
    nameEn: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageSeq: 'cat-accessories-10',
    description: 'Occhiali, gioielli, orologi e piccoli accessori moda',
  },
  {
    id: 'bags',
    nameIt: 'Borse',
    nameEn: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    imageSeq: 'cat-bags-11',
    description: 'Borse, zaini, tracolle e marsupi di design',
  },
  {
    id: 'belts',
    nameIt: 'Cinture',
    nameEn: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageSeq: 'cat-belts-12',
    description: 'Cinture in pelle, tessuto e modelli esclusivi',
  },
  {
    id: 'perfumes',
    nameIt: 'Profumi',
    nameEn: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imageSeq: 'cat-perfumes-13',
    description: 'Profumi, fragranze e colonie ispirate ai grandi marchi',
  },
  {
    id: 'other',
    nameIt: 'Altro',
    nameEn: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageSeq: 'cat-other-14',
    description: 'Altri prodotti interessanti scoperti nei marketplace cinesi',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';